import React from 'react'
import { usePlaceTypes } from '../../utils/helpers/placeTypes'
import { MapIcon } from './_helper/mapHelper'
import { COLORS } from '@btime/constants'
import Tooltip from '../../packages/kiti/components/presentation/Tooltip'

const PinWrapper = ({ children, item = {}, ...props }) => {
  const [placeTypes] = usePlaceTypes()

  return (
    <a {...props}>
      <Tooltip label={item.name} bgColor={COLORS.white}>
        {item.recordType ? <MapIcon item={item} placeTypes={placeTypes} /> : children}
      </Tooltip>
    </a>
  )
}

export default PinWrapper
